import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-docs-persons',
  templateUrl: './docs-persons.component.html',
  styleUrls: ['./docs-persons.component.scss']
})

export class DocsPersonsComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }
}
